import { render, staticRenderFns } from "./admin-console.vue?vue&type=template&id=48ef50f9&"
import script from "./admin-console.vue?vue&type=script&lang=js&"
export * from "./admin-console.vue?vue&type=script&lang=js&"
import style0 from "./admin-console.vue?vue&type=style&index=0&id=48ef50f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports